<template>
  <!--<div class="container">-->
  <div class="columns is-vcentered is-desktop is-mobile is-full-height is-centered">
    <!--<div class="column is-half  ">-->
    <!--<img class="login-logo" src="@/assets/img/digi-logo.png">-->
    <!--</div>-->
    <div :class="{'is-active':showSuccessModal}" class="modal">
      <div class="modal-background" @click.prevent="showSuccessModal=false"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">New Password Set</p>
          <button aria-label="close" class="delete" @click.prevent="showSuccessModal=false"></button>
        </header>
        <section class="modal-card-body">
          <p>Your new password has been set. You can now log in with it.</p>
        </section>
        <footer class="modal-card-foot">
          <b-button type="is-primary" @click.prevent="showSuccessModal=false">Close</b-button>
        </footer>
      </div>
    </div>

    <div class="column is-6-desktop is-10-tablet is-12-mobile login-form">
      <div class="columns is-centered">
        <div class="column is-4">
          <img alt="GENEX logo" class="login-logo"
               src="https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-02.svg"/>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="login">
            <div class="login-content">
              <!--<img class="login-logo" src="@/assets/img/genex-logo.svg">-->
              <p class="pb-4">Please enter in your email address to request a password reset. A recovery link will then
                be emailed to
                you.</p>
              <div class="login-form">
                <form v-on:submit.prevent="setNewPassword">
                  <b-field :message="{'Your new password must be at least 8 characters in length.':passwordLength}"
                           :type="{'is-danger':passwordLength}">
                    <b-input v-model="password"
                             placeholder="Password" required type="password"/>

                  </b-field>
                  <b-field :message="{'Your new password and confirm password must match.':passwordMatch}"
                           :type="{'is-danger':passwordMatch}">
                    <b-input v-model="password_confirmation"
                             placeholder="Confirm Password" required type="password"/>
                  </b-field>


                  <b-field grouped>
                    <p class="control">
                      <b-button tag="router-link" to="/login" type="is-warning">Cancel</b-button>
                    </p>
                    <p class="control">
                      <b-button :disabled="passwordMatch||passwordLength||password ===null" native-type="submit" type="is-primary">
                        Submit
                      </b-button>
                    </p>
                  </b-field>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--</div>-->
</template>
<style lang="scss">
/*.login {*/
/*width: 100%;*/
/*}*/

.login-content {
  margin-left: auto;
  margin-right: auto;

  .login-buttons {
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
}

.login-logo {
  width: 100%;
  /*height: 10rem;*/
}

.login-splash {
  //background-image: url("./src/assets/img/laptop_sofa.jpg");
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
}

/*.login-logo {*/
/*top: 65%;*/
/*position: relative;*/
/*img {*/
/*width: 50%;*/
/*}*/
/*}*/

.mobile-logo {
  width: 50%;
}
</style>
<script>

import {AuthClient} from "@/clients/AuthClient";

export default {
  name: "NewPassword",
  props: ['token'],
  data() {
    return {
      password: null,
      password_confirmation: null,
      showSuccessModal: false
    };
  },
  computed: {
    passwordLength() {
      return this.password !== null && (this.password.length < 8)
    },
    passwordMatch() {
      return this.password_confirmation !== null && (this.password !== this.password_confirmation)
    }
  },
  methods: {

    setNewPassword() {
      if ((this.passwordLength === true) || (this.passwordMatch === true) || (this.password === null)) {
        return
      }
      let data = {
        password: this.password,
        password_confirmation: this.password_confirmation,
        token: this.token
      };
      AuthClient.resetPassword(data).then(() => {
        this.showSuccessModal = true
        this.password = null
        this.password_confirmation = null
        setTimeout(() => {
          this.$router.push({name: 'auth.login'})
        }, 5000)
      }).catch(
          err => {
            this.handleError(err)
          }
      )


    },
  },
};
</script>

<style lang='scss' scoped>
</style>
